// extracted by mini-css-extract-plugin
export default {"mag_home_category_lines_container":"category-lines-tab_mag_home_category_lines_container__V6Xwq"};